import {
  InvestmentPackage,
  Money as MoneyModel,
  PackageStats,
  PackageStatus,
  PackageStatusMapped,
  resolveInvestmentPackageStatus,
} from 'api-client';

import {
  formatEntryDate,
  formatPackageExternalId,
  formatPackageNumber,
  formatRoiIrr,
} from './packageUtils';

export type PackageStatusVariant = 'forming' | 'formed' | 'payout' | 'closed';

export type ComfortPackageRow = {
  key: string;
  packageTitle: string;
  packageId: string;
  packageStatus: PackageStatus;
  entryDate: string;
  invested: MoneyModel;
  returned: MoneyModel | null;
  forecastReturn: MoneyModel | null;
  roiIrr: string | null;
};

const packageStatusVariantMap: Record<PackageStatus, PackageStatusVariant> = {
  [PackageStatus.FORMING]: 'forming',
  [PackageStatus.FORMED]: 'formed',
  [PackageStatus.PAYING]: 'payout',
  [PackageStatus.CLOSED]: 'closed',
};

export const resolvePackageStatus = (
  pkg: InvestmentPackage
): { variant: PackageStatusVariant; label: string; status: PackageStatus } => {
  const status = resolveInvestmentPackageStatus(pkg);

  return {
    status,
    variant: packageStatusVariantMap[status],
    label: PackageStatusMapped[status],
  };
};

export const mapPackageToComfortRow = (
  pkg: InvestmentPackage,
  stats?: PackageStats
): ComfortPackageRow => {
  const status = resolvePackageStatus(pkg);

  return {
    key: pkg.uuid,
    packageTitle: `Пакет #${formatPackageNumber(pkg.uuid)}`,
    packageId: formatPackageExternalId(pkg.uuid),
    packageStatus: status.status,
    entryDate: formatEntryDate(pkg.createdAt),
    invested: stats?.invested ?? pkg.money,
    returned: stats?.incomePaid ?? null,
    forecastReturn: stats?.forecastReturn ?? null,
    roiIrr: stats ? formatRoiIrr(stats.roi, stats.xirr) : null,
  };
};

export { formatEntryDate, formatPackageExternalId, formatPackageNumber, formatRoiIrr };
